exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".camera-wrap[data-v-78356f23]{position:relative;background-color:#e3e3e3;width:240px;height:160px}.camera-wrap[data-v-78356f23],.camera[data-v-78356f23] video{border-radius:8px}", ""]);

// exports
